module.exports = __webpack_public_path__ + "img/h_s2e1_interactions_1.fdcfdc03.png";